import React, { useRef } from 'react';
import BaseSelectImageField from './BaseSelectImageField';
import { GQL_UPLOAD_ASSET } from './graphql';
import { useMutation } from '@apollo/react-hooks';
import { useTranslation } from 'react-i18next';
import { assetToAssetInput } from '../lib/globals/assetToAssetInput';

const UploadSelectImageField = (props) => {
	const [uploadAsset] = useMutation(GQL_UPLOAD_ASSET);
	const fileInputRef = useRef();
	const { t } = useTranslation();

	const handleOpenImageUpload = (uuid, fields) => {
		fileInputRef.current.click();
	};

	const handleFileChange = async (event) => {
		const file = event.target.files[0];
		if (!file) return;
		const { form, name } = props;

		uploadAsset({
			variables: {
				file,
			},
			context: { hasUpload: true },
		})
			.then((result) => {
				const asset = result?.data?.uploadAsset?.asset
				if (asset.id) {
					form.onFieldChange({
						key: name,
						value: asset
					});
				}
			})
			.catch((err) => {
				console.error('Upload failed:', err);
			});
	};

	const handleDeleteImage = (event) => {
		event.stopPropagation();

		if (window.confirm(t('core.select-image-field.confirm-delete'))) {
			const { form, name } = props;

			form.onFieldChange({
				key: name,
				value: {
					id: null,
					url: null,
					bynderId: null,
					derivative: null,
				},
			});
		}
	};

	return (
		<>
			<input type="file" accept="image/*" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} />

			<BaseSelectImageField {...props} handleImageClick={handleOpenImageUpload} handleDeleteImage={handleDeleteImage} />
		</>
	);
};

export default UploadSelectImageField;
